import { cloneDeep } from 'lodash';
import { logisticsService } from '@/api/';
import { DialogMixin } from '@/mixins/dialog';
import { DeliveryModeEnum } from '@/resource/enum';
import { AddLogisticsParams, SaveLogistics } from '@/resource/model';
import { messageError, translation } from '@/utils';
import { Message } from 'element-ui';
import { ElForm } from 'element-ui/types/form';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
type LogisticsForm = Pick<SaveLogistics, 'sendRemark' | 'senderType' | 'shopCount' | 'receivingCompany'>;
@Component({
  components: {}
})
export default class AddLogistics extends mixins(DialogMixin) {
  @Prop({ type: Object, required: true })
  public readonly deliveryParams!: AddLogisticsParams;

  public form: Partial<LogisticsForm> = {
    sendRemark: this.deliveryParams.deliveryNoticeCode.split('-').shift(),
    senderType: this.deliveryParams.sendMethod ?? DeliveryModeEnum.TPL,
    shopCount: undefined,
    receivingCompany: undefined
  };

  public deliveryModes: Array<{ label: string; value: string }> = [];

  public formRules: { [p in keyof Partial<LogisticsForm>]: Array<object> } = {
    senderType: [
      {
        required: true,
        validator: (rule: any, value: DeliveryModeEnum, callback: Function): void => {
          if (!value) {
            callback(new Error(translation('logistics.selectDelivertMode')));
            return;
          }
          callback();
        },
        trigger: 'change'
      }
    ],
    shopCount: [
      {
        required: true,
        validator: (rule: any, value: number, callback: Function): void => {
          if (!value || value === 0) {
            callback(new Error(translation('logistics.inputChildCount')));
            return;
          }
          callback();
        },
        trigger: 'blur'
      }
    ]
  };

  public created(): void {
    this.deliveryModes = logisticsService.getDeliveryMode();
  }

  public submit(): void {
    (this.$refs.form as ElForm).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      const copyForm = cloneDeep(this.form);
      const logistics = Object.assign(copyForm, this.deliveryParams);
      if (this.form.receivingCompany) {
        logistics.receivingCompany = this.form.receivingCompany.trim();
      }
      
      this.setLoading(true);
      try {
        await logisticsService.post(logistics as SaveLogistics);
        Message.success(translation('operationRes.addSuccess'));
        this.$emit('add-success');
        this.closeDialog();
      } catch (error) {
        messageError(error);
      } finally {
        this.setLoading(false);
      }
    });
  }
}
